import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  sectionIndent: {
    marginBottom: '42px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '32px',
    },
  },
  inputIndent: {
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
     paddingLeft: '20px'
    },
  },
  guestInfoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px',
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginBottom: '16px',
      padding: '0px 20px '
    },
  },
  guestInfoField: {
    width: '280px',
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '16px',
       padding: '0px 20px '
    },
  },
}));

export default useStyles;
